module.exports = __webpack_public_path__ + "img/ripley.4282c23.png";